import { io, type Socket } from "socket.io-client";
import { API_URL, getToken } from "./api";

let socket: Socket | null = null;

/** Lazily create the shared Socket.io connection and authenticate as staff. */
export function getSocket(): Socket {
  if (socket) return socket;

  socket = io(API_URL || window.location.origin, {
    transports: ["websocket", "polling"],
    autoConnect: true,
  });

  const join = () => {
    const token = getToken();
    if (token) socket?.emit("staff:join", { token });
  };
  socket.on("connect", join);
  if (socket.connected) join();

  return socket;
}

export function disconnectSocket(): void {
  socket?.disconnect();
  socket = null;
}
